import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import type { SxProps } from '@mui/material';
export const Cancel = t0 => {
  const $ = _c(5);
  const {
    onClick,
    sx
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = {
      cursor: "pointer",
      ...sx
    };
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClick || $[3] !== t1) {
    t2 = <CloseOutlined sx={t1} onClick={onClick} />;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};